import Swiper, { Pagination, Autoplay, EffectFade } from "swiper";
import "swiper/swiper-bundle.css";

window.addEventListener("load", () => {
  const teamSliders = document.querySelectorAll(".team");
  if (teamSliders.length > 0) {
    teamSliders.forEach((element) => {
      const swiper = new Swiper(element.querySelector(".team__swiper"), {
        modules: [Pagination, EffectFade, Autoplay],
        slidesPerView: "1",
        loop: true,
        autoplay: {
          delay: 5000,
          pauseOnMouseEnter: true,
        },
        speed: 1500,
        pagination: {
          el: element.querySelector(".team-title__swiper-pagination"),
          clickable: true,
        },
      });
      swiper.init();
    });
  }
});

